export default __webpack_public_path__ + "static/Nicholas Husser-adef45671c4064f0c66a52ce1cb737a4.jpeg";